import { IHxfBarcodeScanFormat } from "../../components/HxfBarcodeScanner/HxfBarcodeScanner";

function ProductionOrdersService(){

    const getResponseAllowedScans = (flags:any, optionsScan:any) => {

        let allowedScans: IHxfBarcodeScanFormat[] = [];
          if (
            optionsScan.useCamera &&
            !optionsScan.useExternalDevice
          ) {
            optionsScan.initCameraOnStartUp = true;
          }
          //checking for auto selection scan
          if (
            flags?.setting_shopfloor_productionOrders_autoSel_labelScan_barcode39
          ) {
            let scanType: IHxfBarcodeScanFormat = {
              type: "barcode39",
              pattern:
                flags?.setting_shopfloor_productionOrders_autoSel_labelScan_barcode39,
            };
            allowedScans.push(scanType);
            //allow fallback method to production order Id only, ex: if it accepts [poid,popid] and doesnt find popid only poid
            if (
              flags?.setting_shopfloor_productionOrders_autoSel_labelScan_barcode39 !==
              "[productionorder.id]"
            ) {
              let scanType2: IHxfBarcodeScanFormat = {
                type: "barcode39",
                pattern: "[productionorder.id]",
              };
              allowedScans.push(scanType2);
            }
          }

          if (flags?.setting_shopfloor_productionOrders_autoSel_labelScan_barcode128
          ) {
            let scanType: IHxfBarcodeScanFormat = {
              type: "barcode128",
              pattern:flags?.setting_shopfloor_productionOrders_autoSel_labelScan_barcode128,
            };
            allowedScans.push(scanType);
            //allow fallback method to production order Id only, ex: if it accepts [poid,popid] and doesnt find popid only poid
            if (flags?.setting_shopfloor_productionOrders_autoSel_labelScan_barcode128 !==
              "[productionorder.id]"
            ) {
              let scanType2: IHxfBarcodeScanFormat = {
                type: "barcode128",
                pattern: "[productionorder.id]",
              };
              allowedScans.push(scanType2);
            }
          }

          if (flags?.setting_shopfloor_productionOrders_autoSel_labelScan_qr
          ) {
            let scanType: IHxfBarcodeScanFormat = {
              type: "qrcode",
              pattern:flags?.setting_shopfloor_productionOrders_autoSel_labelScan_qr,
            };
            allowedScans.push(scanType);

            //allow fallback method to production order Id only, ex: if it accepts [poid,popid] and doesnt find popid only poid
            if (flags?.setting_shopfloor_productionOrders_autoSel_labelScan_qr !==
              "[productionorder.id]"
            ) {
              let scanType2: IHxfBarcodeScanFormat = {
                type: "qrcode",
                pattern: "[productionorder.id]",
              };
              allowedScans.push(scanType2);
            }
          }
          return allowedScans;
    }

    return {getResponseAllowedScans};
}

export default ProductionOrdersService;